import { t } from 'i18next';
import * as yup from 'yup';

import vetaCenterTextSchema from '~utils/vetaCenterTextSchema';

const MAX_GROSS_WEIGHT_IN_TONS = 200;

const companySharesSchema = yup
  .array()
  .of(
    yup.object().shape({
      id: yup.string(),
      receiverCompany: yup.object().shape({
        id: yup.string().required(),
        legalName: yup.string(),
      }),
      dispatchable: yup.object().shape({
        id: yup.string(),
        name: yup.string(),
      }),
      ticketMatchId: yup.string(),
      companyShareableId: yup.string(),
    }),
  )
  .notRequired();

export const sharedEquipmentFormValidationSchema = yup.object().shape({
  companySpecificId: yup.string(),
  companyShares: companySharesSchema,
});

export const externalEquipmentFormValidationSchema = yup.object().shape({
  name: yup.string(),
  externalId: yup.string(),
  ticketMatchId: yup.string(),
  companyShares: companySharesSchema,
});

const homeBaseSchema = yup
  .object()
  .shape({
    id: yup.string(),
    siteId: yup.string().nullable(),
    name: yup.string(),
    lat: yup.string().nullable(),
    lng: yup.string().nullable(),
    address: yup.object().nullable(),
    type: yup.string(),
    placeId: yup.string(),
  })
  .nullable()
  .notRequired();

export const equipmentFormValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required(
      `${t('form_validation_errors.required', { field: t('form_fields.first_name') })}`,
    ),
  id: yup.string(),
  company: yup
    .object()
    .shape({
      id: yup.string(),
      legalName: yup.string(),
    })
    .typeError(
      `${t('form_validation_errors.required', { field: t('form_fields.company') })}`,
    )
    .required(
      `${t('form_validation_errors.required', { field: t('form_fields.company') })}`,
    ),
  type: yup
    .object()
    .shape({
      name: yup.string(),
      id: yup.string().required(),
      system: yup.boolean(),
    })
    .required(`${t('form_validation_errors.required_simple')}`),
  externalId: yup.string(),
  licenseNumber: yup.string(),
  isNotActive: yup.boolean(),
  ownedByAccount: yup
    .object()
    .shape({
      label: yup.string().required(),
      value: yup.string().defined(),
    })
    .default(undefined)
    .notRequired(),
  shareName: yup.string(),
  shareTicketMatchId: yup.string(),
  companySpecificId: yup.string(),
  companyShares: companySharesSchema,
  accountingId: yup.string(),
  zone: yup.string(),
  overweightPermitNumber: vetaCenterTextSchema(
    t('administration.equipment.overweight_permit_number'),
  ),
  maxGrossWeight: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .min(0.01, t('form_validation_errors.minimum_is_num', { num: 0.01 }))
    .max(
      MAX_GROSS_WEIGHT_IN_TONS,
      t('form_validation_errors.max_tons', { max: MAX_GROSS_WEIGHT_IN_TONS }),
    ),
  homeBase: homeBaseSchema,
  labels: yup
    .array()
    .of(
      yup.object({
        id: yup.string().required(),
        name: yup.string().required(),
        color: yup.string(),
      }),
    )
    .max(5)
    .notRequired(),
});
